import * as React from "react";
const SvgFiRrWrenchAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wrench-alt_svg__a)">
      <path
        fill="#062147"
        d="M3.688 24h-.095a3.66 3.66 0 0 1-2.649-1.224c-1.269-1.409-1.157-3.784.244-5.185l5.868-5.867c.253-.254.344-.63.241-1.009a8.5 8.5 0 0 1-.102-4.036C7.903 3.364 10.626.735 13.972.137A8.5 8.5 0 0 1 16.974.13a1.91 1.91 0 0 1 1.52 1.325c.251.8-.003 1.681-.682 2.36L15.565 6.03c-.658.658-.758 1.69-.222 2.345.308.378.742.598 1.222.622a1.7 1.7 0 0 0 1.271-.489l2.58-2.55a2.04 2.04 0 0 1 2.07-.5 2.01 2.01 0 0 1 1.385 1.566 8.6 8.6 0 0 1-.007 3.003c-.6 3.347-3.229 6.07-6.544 6.777a8.5 8.5 0 0 1-4.036-.103c-.377-.104-.754-.012-1.008.241L6.3 22.918A3.7 3.7 0 0 1 3.688 24M15.61 1.993c-.422 0-.854.035-1.286.112-2.554.457-4.634 2.463-5.174 4.991a6.5 6.5 0 0 0 .076 3.093c.29 1.062 0 2.191-.756 2.948l-5.868 5.867c-.65.65-.732 1.81-.17 2.433.314.35.746.55 1.214.562.461.02.91-.163 1.241-.494l5.975-5.975c.755-.755 1.885-1.047 2.948-.757 1.004.274 2.045.3 3.093.076 2.528-.539 4.534-2.618 4.992-5.174a6.5 6.5 0 0 0 .006-2.3v-.008l-2.655 2.56a3.62 3.62 0 0 1-2.78 1.067 3.7 3.7 0 0 1-2.67-1.353c-1.179-1.439-1.02-3.649.361-5.03l2.247-2.217c.18-.18.191-.314.184-.34a8 8 0 0 0-.976-.063z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wrench-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWrenchAlt;
